{
  "WALLBOARD": {
    "LOADING": "Đang tải hàng đợi cuộc gọi...",
    "NO_QUEUES": "Không tìm thấy hàng đợi cuộc gọi nào.",
    "NO_AGENTS": "Không có nhân viên nào trực tuyến trong hàng đợi này.",
    "UNKNOWN_CALLER": "Người gọi không xác định",
    "STATUS": "Trạng thái",
    "TIME": "Thời gian",
    "AGENT": "Nhân viên",
    "EXTENSION": "Số nội bộ",
    "READY": "Nhân viên sẵn sàng",
    "ON_CALL": "Nhân viên đang gọi",
    "PAUSED": "Nhân viên đang nghỉ",
    "WAITING": "Cuộc gọi đang chờ",
    "MISSED_CALLS": "Cuộc gọi nhỡ",
    "HANDLED_CALLS": "Cuộc gọi đến đã xử lý",
    "OUTBOUND_CALLS": "Cuộc gọi đi đã xử lý",
    "AVAILABILITY": "Mức độ sẵn sàng",
    "AVAILABILITY_TOOLTIP": "Tỷ lệ phần trăm cuộc gọi đến được nhân viên trả lời (cuộc gọi đã được bắt máy)",
    "AGENTS_COUNT": "({onCall} đang gọi / {total} tổng số)",
    "NO_AVAILABLE": "(không có ai trực tuyến)",
    "WAITING_CALLERS_COUNT": "{count} đang chờ",
    "CALLER": "Người gọi",
    "NUMBER": "Số điện thoại",
    "WAIT_TIME": "Thời gian chờ",
    "ACTION": "Hành động",
    "PICKUP_CALL": "Bắt máy",
    "PICKUP_SUCCESS": "Đã gửi yêu cầu bắt máy thành công.",
    "PICKUP_ERROR": "Không thể bắt máy. Vui lòng thử lại.",
    "PICKUP_DISABLED_TOOLTIP": "Bạn không thể bắt máy khi đang trong cuộc gọi khác hoặc đang ngoại tuyến.",
    "CHAT_STATUS": {
      "NO_ACCESS": "Không có quyền truy cập"
    },
    "PHONE_STATUS": {
      "NO_ACCESS": "Không có quyền truy cập"
    }
  }
}
